import React from "react";
import s from "./style.module.scss";
import PropTypes from "prop-types";

const Container = (props) => (
  <div className={s.container + " " + (props.className ? props.className : "")}>
    {props.children}
  </div>
);

Container.propTypes = {
  className: PropTypes.string,
};

Container.defaultProps = {
  className: "",
};

export default Container;
